import { IMenu, menuIdNames } from '../interfaces/header';
import { formRegistrationUrl, refRegistrationParams } from '../scripts/registration';
export const menus: IMenu[] = [
  {
    id: 'rpt' as menuIdNames,
    titleCopy: 'Credit',
    dataLink: 'nav-ia-credit',
    mainLink: '/consumer-products/compare-credit-report-and-score-products.html',
    adviceTitle: 'Credit advice',
    drpMainCategories: [
      {
        advice: {
          mobileTitle: 'Most popular',
          links: [
            {
              title: 'What is a good credit score?',
              link: '/blogs/ask-experian/credit-education/score-basics/what-is-a-good-credit-score/',
            },
            {
              title: 'Credit score ranges',
              link: '/blogs/ask-experian/infographic-what-are-the-different-scoring-ranges/',
            },
            {
              title: 'Average credit score in the U.S.',
              link: '/blogs/ask-experian/what-is-the-average-credit-score-in-the-u-s/',
            },
            {
              title: 'Improving your credit',
              link: '/blogs/ask-experian/credit-education/improving-credit/improve-credit-score/',
            },
            {
              title: 'How to build credit',
              link: '/blogs/ask-experian/credit-education/improving-credit/building-credit/',
            },
          ],
        },
      },
      {
        link: '/consumer-products/free-credit-report.html',
        title: 'Free credit report',
        subcopy: 'See your latest credit information',
        icon: 'ecs-font-icon-frs-report-experian',
        advice: {
          mobileTitle: 'Credit reports',
          links: [
            {
              title: 'How to remove credit inquiries',
              link: '/blogs/ask-experian/how-to-remove-hard-inquiries-from-credit-report/',
            },
            {
              title: 'Collections on your credit report',
              link: '/blogs/ask-experian/credit-education/report-basics/how-and-when-collections-are-removed-from-a-credit-report/',
            },
            {
              title: 'What is a charge-off?',
              link: '/blogs/ask-experian/what-is-a-charge-off/',
            },
            {
              title: 'How bankruptcy works',
              link: '/blogs/ask-experian/credit-education/bankruptcy-how-it-works-types-and-consequences/',
            },
            {
              title: 'When are late payments reported?',
              link: '/blogs/ask-experian/when-do-late-payments-get-reported/',
            },
          ],
        },
      },
      {
        link: '/consumer-products/credit-score.html',
        title: 'Free credit score',
        subcopy: 'Get to know your FICO<sup>®</sup> Score',
        icon: 'ecs-font-icon-frs-score',
        advice: {
          mobileTitle: 'Credit scores',
          links: [
            {
              title: 'What is a perfect credit score?',
              link: '/blogs/ask-experian/perfect-scores-who-has-them-and-what-do-they-have-in-common/',
            },
            {
              title: 'Different types of credit scores',
              link: '/blogs/ask-experian/what-is-the-difference-between-fico-score-and-credit-score/',
            },
            {
              title: 'What factors affect your credit score?',
              link: '/blogs/ask-experian/credit-education/score-basics/what-affects-your-credit-scores/',
            },
            {
              title: 'How the FICO<sup>®</sup> Score Simulator works',
              link: '/blogs/ask-experian/how-does-credit-score-simulator-work/',
            },
            {
              title: 'Why did your credit score drop?',
              link: '/blogs/ask-experian/why-did-my-credit-score-drop/',
            },
          ],
        },
      },
      {
        link: '/consumer-products/score-boost.html',
        title: 'Experian Boost<sup>®</sup>',
        subcopy: 'Raise your credit scores instantly',
        icon: 'ecs-font-icon-frs-rocket-boost',
        advice: {
          mobileTitle: 'Improving credit',
          links: [
            {
              title: 'Why isn’t your credit score increasing?',
              link: '/blogs/ask-experian/reasons-your-credit-score-isnt-increasing/',
            },
            {
              title: 'When does your credit score improve?',
              link: '/blogs/ask-experian/how-long-after-you-pay-off-debt-does-your-credit-improve/',
            },
            {
              title: 'Does a mortgage hurt your credit score?',
              link: '/blogs/ask-experian/does-mortgage-hurt-credit-score/',
            },
            {
              title: 'How to build credit with credit cards',
              link: '/blogs/ask-experian/how-to-use-a-credit-card-to-build-credit/',
            },
            {
              title: 'How credit repair works',
              link: '/blogs/ask-experian/credit-education/improving-credit/credit-repair/',
            },
          ],
        },
      },
      {
        link: '/consumer-products/experian-go.html',
        title: 'Experian Go™',
        subcopy: 'Establish and build your credit',
        icon: 'ecs-font-icon-frs-chart-grow',
        advice: {
          mobileTitle: 'Establishing credit',
          links: [
            {
              title: 'How to build credit with no credit history',
              link: '/blogs/ask-experian/how-to-build-credit-with-no-credit-history/',
            },
            {
              title: 'How to establish credit',
              link: '/blogs/ask-experian/how-to-establish-credit-as-a-young-person/',
            },
            {
              title: 'How to get first-time credit',
              link: '/blogs/ask-experian/how-can-i-get-credit-for-the-first-time/',
            },
            {
              title: 'What does “credit invisible” mean?',
              link: '/blogs/ask-experian/what-does-being-credit-invisible-mean/',
            },
            {
              title: 'Credit mistakes to avoid',
              link: '/blogs/ask-experian/common-credit-mistakes-to-avoid/',
            },
          ],
        },
      },
    ],
    drpTabFixed: {
      title: 'Credit support',
      links: [
        { title: 'Security freeze', link: '/freeze/center.html' },
        { title: 'Disputes', link: '/disputes/main.html' },
        { title: 'Fraud alert', link: '/fraud/center.html' },
        {
          title: 'Contact us',
          link: '/contact/personal-services-contacts.html',
        },
      ],
    },
    promo: {
      badge: 'Experian<sup>®</sup> Boost',
      title: 'Boost your credit by paying rent',
      body: 'Pay rent online? Now it could raise your credit scores instantly.',
      linkTitle: 'Find out how',
      link: '/consumer-products/score-boost.html',
    },
  },
  {
    id: 'itp' as menuIdNames,
    titleCopy: 'Protection',
    mainLink: '/protection/compare-identity-theft-products/',
    dataLink: 'nav-ia-protection',
    adviceTitle: 'Identity Theft Advice',
    drpMainCategories: [
      {
        advice: {
          mobileTitle: 'Most popular',
          links: [
            {
              title: 'What is identity theft?',
              link: '/blogs/ask-experian/what-is-identity-theft/',
            },
            {
              title: 'How to protect your identity',
              link: '/blogs/ask-experian/how-to-protect-yourself-from-identity-theft/',
            },
            {
              title: 'How to remove fraud from your credit report',
              link: '/blogs/ask-experian/how-to-remove-fraud-information-from-credit-report/',
            },
            {
              title: 'What is the dark web?',
              link: '/blogs/ask-experian/what-is-the-dark-web/',
            },
            {
              title: 'What are the latest scams?',
              link: '/blogs/ask-experian/the-latest-scams-you-need-to-aware-of/',
            },
          ],
        },
      },
      {
        link: '/protection/identity-theft-and-credit-protection/',
        title: 'Identity theft and fraud',
        subcopy: 'ID monitoring, alerts and protection',
        icon: 'ecs-font-icon-idt-shield-lock',
        advice: {
          mobileTitle: 'Identity theft and fraud',
          links: [
            {
              title: 'How to check for identity theft',
              link: '/blogs/ask-experian/how-do-you-check-for-identity-theft/',
            },
            {
              title: 'What if your Social Security number is stolen?',
              link: '/blogs/ask-experian/3-steps-to-take-if-your-social-security-number-has-been-stolen/',
            },
            {
              title: 'How to avoid identity theft',
              link: '/blogs/ask-experian/credit-education/preventing-fraud/',
            },
            {
              title: 'Types of identity theft',
              link: '/blogs/ask-experian/20-types-of-identity-theft-and-fraud/',
            },
          ],
        },
      },
      {
        link: '/protection/free-dark-web-email-scan/',
        title: 'Free dark web scan',
        subcopy: 'Scan for your SSN, phone and email',
        icon: 'ecs-font-icon-idt-dark-web',
        advice: {
          mobileTitle: 'Cybersecurity',
          links: [
            {
              title: 'Identity protection tools',
              link: '/blogs/ask-experian/10-identity-protection-tools-and-measures-you-can-use/',
            },
            {
              title: 'What to do about a data breach',
              link: '/blogs/ask-experian/data-breach-five-things-to-do-after-your-information-has-been-stolen/',
            },
            {
              title: 'Protecting your identity while online shopping',
              link: '/blogs/ask-experian/how-to-protect-your-identity-while-shopping-online/',
            },
            {
              title: 'Tips for victims of credit card fraud',
              link: '/blogs/ask-experian/credit-education/preventing-fraud/credit-card-fraud-what-to-do-if-you-are-a-victim/',
            },
          ],
        },
      },
      {
        link: '/protection/personal-privacy-scan/',
        title: 'Free personal privacy scan',
        subcopy: 'Find your info on people finder sites',
        icon: 'ecs-font-icon-ppl-user-data',
        advice: {
          mobileTitle: 'Privacy',
          links: [
            {
              title: 'How to protect your info online',
              link: '/blogs/ask-experian/how-do-you-protect-your-personal-information-online/',
            },
            {
              title: 'Removing your info from people search sites',
              link: '/blogs/ask-experian/how-to-remove-your-information-from-people-search-sites/',
            },
            {
              title: 'How to get off robocall lists',
              link: '/blogs/ask-experian/how-to-remove-your-name-from-robocall-lists/',
            },
            {
              title: 'Social media safety tips',
              link: '/blogs/ask-experian/9-ways-to-stay-safe-on-social-media/',
            },
          ],
        },
      },
    ],
    drpTabFixed: {
      title: 'Identity Theft support',
      links: [
        { title: 'Security freeze', link: '/freeze/center.html' },
        { title: 'Fraud alert', link: '/fraud/center.html' },
        { title: 'Disputes', link: '/disputes/main.html' },
        {
          title: 'Contact us',
          link: '/contact/personal-services-contacts.html',
        },
      ],
    },
    promo: {
      badge: 'PRIVACY SCAN',
      title: 'Is your personal info at risk?',
      body: 'See if your address, email and more are exposed on people finder sites.',
      linkTitle: 'Scan for free',
      link: '/protection/personal-privacy-scan/',
    },
  },
  {
    id: 'mon' as menuIdNames,
    titleCopy: 'Money',
    mainLink: '/money/experian-smart-money/',
    dataLink: 'nav-ia-money',
    adviceTitle: 'Money advice',
    drpMainCategories: [
      {
        subcopy: `Check out Experian Smart Money™`,
        icon: 'ecs-font-icon-ccm-credit-card',
        link: '/money/experian-smart-money/',
        title: 'Digital checking account',
        advice: {
          mobileTitle: 'Digital checking account',
          links: [
            {
              title: 'Routing number vs. account number',
              link: '/blogs/ask-experian/what-is-the-difference-between-routing-and-account-numbers/',
            },
            {
              title: 'What is a high-yield checking account?',
              link: '/blogs/ask-experian/what-is-high-yield-checking-account/',
            },
            {
              title: 'Are all checking accounts free?',
              link: '/blogs/ask-experian/are-all-checking-accounts-free/',
            },
            {
              title: 'How do bank account bonuses work?',
              link: '/blogs/ask-experian/how-do-bank-account-bonuses-work/',
            },
            {
              title: 'Why was I denied a checking account?',
              link: '/blogs/ask-experian/why-was-i-denied-a-checking-account/',
            },
          ],
        },
      },
      {
        subcopy: `We’ll negotiate bills for you & cancel unwanted subscriptions`,
        icon: 'ecs-font-icon-idt-report-bank',
        link: '/lp/financial-health.html',
        title: 'Manage your expenses',
        advice: {
          mobileTitle: 'Save money on bills',
          links: [
            {
              title: 'Pros and cons of high-yield savings accounts',
              link: '/blogs/ask-experian/pros-cons-high-yield-savings-account/',
            },
            {
              title: 'Savings accounts that pay high interest',
              link: '/blogs/ask-experian/which-type-of-savings-account-pays-highest-interest-rate/',
            },
            {
              title: 'Are CDs worth it?',
              link: '/blogs/ask-experian/are-cds-worth-it/',
            },
            {
              title: 'Ways to spend less and save more',
              link: '/blogs/ask-experian/ways-to-spend-less-and-save-more/',
            },
            {
              title: 'How good credit can save you money',
              link: '/blogs/ask-experian/how-having-a-good-credit-can-save-you-money/',
            },
          ],
        },
      },
    ],
    promo: {
      badge: 'NEW! EXPERIAN SMART MONEY™',
      title: 'Build credit without the debt<sup>Ø</sup>',
      body: 'Try a digital checking account designed by credit experts—with no monthly fees.<sup>¶</sup>',
      linkTitle: 'Get details',
      link: '/money/experian-smart-money/',
    },
    underPromo:
      'Banking services provided by Community Federal Savings Bank, Member FDIC. Experian is not a bank.',
  },
  {
    id: 'crd' as menuIdNames,
    titleCopy: 'Credit Cards',
    mainLink: '/credit-cards/',
    dataLink: 'nav-ia-creditcards',
    adviceTitle: 'Credit Card advice',
    drpMainCategories: [
      {
        link: '/credit-cards/',
        title: 'All credit card types',
        icon: 'ecs-font-icon-ccm-credit-card',
        advice: {
          mobileTitle: 'Most popular',
          links: [
            {
              title: 'How to use a credit card to build credit',
              link: '/blogs/ask-experian/how-to-use-a-credit-card-to-build-credit/',
            },
            {
              title: 'Best instant-use credit cards',
              link: '/blogs/ask-experian/best-instant-use-credit-cards/',
            },
            {
              title: 'Best credit cards with no annual fee',
              link: '/blogs/ask-experian/best-no-annual-fee-credit-cards/',
            },
            {
              title: 'How to choose a credit card',
              link: '/blogs/ask-experian/how-to-choose-a-credit-card/',
            },
            {
              title: 'What is an APR?',
              link: '/blogs/ask-experian/what-is-apr/',
            },
            {
              title: 'Paying off a credit card early',
              link: '/blogs/ask-experian/what-happens-if-i-pay-my-credit-card-early/',
            },
            {
              title: 'Average credit card debt',
              link: '/blogs/ask-experian/state-of-credit-cards/',
            },
            {
              title: 'Credit card payoff calculator',
              link: '/blogs/ask-experian/credit-card-payoff-calculator/',
            },
          ],
        },
      },
      {
        link: '/credit-cards/best-balance-transfer/',
        title: 'Balance transfer',
        icon: 'ecs-font-icon-ccm-balance-transfer',
        advice: {
          mobileTitle: 'Balance transfer',
          links: [
            {
              title: 'How balance transfers work',
              link: '/blogs/ask-experian/what-is-a-balance-transfer-and-how-does-it-work/',
            },
            {
              title: 'Balance transfer vs. debt consolidation loan',
              link: '	/blogs/ask-experian/should-i-get-a-balance-transfer-card-or-debt-consolidation-loan/',
            },
            {
              title: 'What is a balance transfer APR?',
              link: '/blogs/ask-experian/what-is-balance-transfer-apr/',
            },
            {
              title: 'What is a credit limit?',
              link: '/blogs/ask-experian/what-is-a-credit-limit/',
            },
            {
              title: 'What is a credit utilization rate?',
              link: '/blogs/ask-experian/credit-education/score-basics/credit-utilization-rate/',
            },
          ],
        },
      },
      {
        link: '/credit-cards/best-cash-back/',
        title: 'Cash back',
        icon: 'ecs-font-icon-ccm-cashback',
        advice: {
          mobileTitle: 'Cash back',
          links: [
            {
              title: 'How cash back works',
              link: '/blogs/ask-experian/how-do-cash-back-credit-cards-work/',
            },
            {
              title: 'Getting the most cash back',
              link: '/blogs/ask-experian/get-the-most-cash-back-with-these-credit-cards/',
            },
            {
              title: 'Cash back vs. points',
              link: '/blogs/ask-experian/cash-back-vs-points-which-rewards-credit-card-is-better/',
            },
            {
              title: 'Best credit cards with an intro bonus',
              link: '/blogs/ask-experian/best-credit-card-intro-bonus/',
            },
          ],
        },
      },
      {
        link: '/credit-cards/best-for-bad-credit/',
        title: 'For bad credit',
        icon: 'ecs-font-icon-frs-score-bad',
        advice: {
          mobileTitle: 'For bad credit',
          links: [
            {
              title: 'Applying for a credit card with bad credit',
              link: '/blogs/ask-experian/how-to-apply-for-a-credit-card-with-bad-credit/',
            },
            {
              title: 'Balance transfer cards with bad credit',
              link: '/blogs/ask-experian/can-i-get-a-balance-transfer-card-with-bad-credit/',
            },
            {
              title: 'Getting a credit card after bankruptcy',
              link: '/blogs/ask-experian/can-i-get-a-credit-card-after-bankruptcy/',
            },
            {
              title: 'What is a charge-off?',
              link: '/blogs/ask-experian/what-is-a-charge-off/',
            },
            {
              title: 'Reasons for a denied credit card application',
              link: '/blogs/ask-experian/why-was-my-credit-card-application-denied/',
            },
          ],
        },
      },
      {
        link: '/credit-cards/best-for-fair-credit/',
        title: 'For fair credit',
        icon: 'ecs-font-icon-frs-score-fair',
        advice: {
          mobileTitle: 'For fair credit ',
          links: [
            {
              title: 'Easiest credit cards to get with fair credit',
              link: '/blogs/ask-experian/what-is-the-easiest-credit-card-to-get-with-fair-credit/',
            },
            {
              title: 'Credit cards for a 600 score',
              link: '/blogs/ask-experian/what-credit-card-is-good-for-a-600-credit-score/',
            },
            {
              title: 'How to pre-qualify for a credit card',
              link: '/blogs/ask-experian/how-to-prequalify-for-a-credit-card/',
            },
            {
              title: 'Best credit cards for fair credit',
              link: '/blogs/ask-experian/best-credit-cards-for-fair-credit/',
            },
          ],
        },
      },
      {
        link: '/credit-cards/best-student/',
        title: 'For students',
        icon: 'ecs-font-icon-ccm-student',
        advice: {
          mobileTitle: 'For students',
          links: [
            {
              title: 'Best credit cards for beginners',
              link: '/blogs/ask-experian/best-starter-credit-cards/',
            },
            {
              title: 'Guide to student credit cards',
              link: '/blogs/ask-experian/how-to-get-a-student-credit-card/',
            },
            {
              title: 'Best credit cards for teens',
              link: '/blogs/ask-experian/best-credit-cards-for-teens/',
            },
            {
              title: 'How to use a credit card responsibly',
              link: '/blogs/ask-experian/how-to-use-a-credit-card-responsibly/',
            },
          ],
        },
      },
      {
        link: '/credit-cards/best-low-interest/',
        title: 'Low interest',
        icon: 'ecs-font-icon-frs-chart-down',
        advice: {
          mobileTitle: 'APR',
          links: [
            {
              title: 'What is a good APR?',
              link: '/blogs/ask-experian/what-is-a-good-apr-for-a-credit-card/',
            },
            {
              title: 'How to negotiate a lower APR',
              link: '/blogs/ask-experian/can-i-negotiate-a-lower-interest-rate-on-my-credit-card/',
            },
            {
              title: 'What impacts your APR?',
              link: '/blogs/ask-experian/what-can-increase-credit-card-apr/',
            },
            {
              title: 'Best 0% intro APR credit cards',
              link: '/blogs/ask-experian/best-zero-percent-apr-credit-cards/',
            },
            {
              title: 'How much available credit should you have?',
              link: '/blogs/ask-experian/how-much-available-credit-should-i-have/',
            },
            {
              title: 'APR calculator',
              link: '/blogs/ask-experian/apr-calculator/',
            },
          ],
        },
      },
      {
        link: '/credit-cards/best-rewards/',
        title: 'Rewards',
        icon: 'ecs-font-icon-con-rewards-gift',
        advice: {
          mobileTitle: 'Rewards',
          links: [
            {
              title: 'Best credit cards for travel & hotels',
              link: '/blogs/ask-experian/best-travel-credit-cards/',
            },
            {
              title: 'Best credit cards for gas purchases',
              link: '/blogs/ask-experian/best-credit-cards-for-gas-purchases/',
            },
            {
              title: 'Best credit cards for dining',
              link: '/blogs/ask-experian/best-credit-cards-for-restaurants-dining/',
            },
            {
              title: 'Best credit cards for groceries',
              link: '/blogs/ask-experian/best-credit-cards-for-groceries/',
            },
            {
              title: 'Credit cards with the best perks',
              link: '/blogs/ask-experian/best-credit-card-benefits/',
            },
          ],
        },
      },
      {
        link: '/credit-cards/best-secured/',
        title: 'Secured',
        icon: 'ecs-font-icon-idt-shield-lock',
        advice: {
          mobileTitle: 'New to credit',
          links: [
            {
              title: 'What is a secured credit card?',
              link: '/blogs/ask-experian/what-is-a-secured-credit-card/',
            },
            {
              title: 'How to use a secured credit card',
              link: '/blogs/ask-experian/how-to-use-a-secured-credit-card/',
            },
            {
              title: 'How secured credit card deposits work',
              link: '/blogs/ask-experian/how-does-the-deposit-in-a-secured-card-work/',
            },
            {
              title: 'Secured vs. pre-paid credit cards',
              link: '/blogs/ask-experian/secured-card-or-prepaid-card-which-credit-card-is-best-for-you/',
            },
          ],
        },
      },
    ],
    promo: {
      badge: 'Credit cards',
      title: 'Get matched before you apply',
      body: 'We’ll find the best credit cards for you based on your credit profile.',
      linkTitle: 'See your matches',
      link: '/credit-cards/',
    },
  },
  {
    id: 'lns' as menuIdNames,
    titleCopy: 'Loans',
    mainLink: '/credit/loans/',
    dataLink: 'nav-ia-loans',
    adviceTitle: 'Loan advice',
    drpMainCategories: [
      {
        link: '/credit/loans/',
        title: 'All loan types',
        icon: 'ecs-font-icon-frs-bank',
        advice: {
          mobileTitle: 'Most popular',
          links: [
            {
              title: 'Best personal loans for bad credit',
              link: '/blogs/ask-experian/best-personal-loan-lenders-for-bad-credit/',
            },
            {
              title: 'How to get a personal loan with fair credit',
              link: '/blogs/ask-experian/can-i-get-a-personal-loan-with-fair-credit/',
            },
            {
              title: 'How does a personal loan impact your credit score?',
              link: '/blogs/ask-experian/how-does-a-personal-loan-impact-your-credit/',
            },
            {
              title: 'How to get an emergency loan',
              link: '/blogs/ask-experian/emergency-loans-where-to-get-the-best-ones/',
            },
            {
              title: 'How cosigning a loan affects your credit',
              link: '/blogs/ask-experian/how-does-cosigning-affect-your-credit/',
            },
            {
              title: 'Personal loan calculator',
              link: '/blogs/ask-experian/personal-loan-calculator/',
            },
          ],
        },
      },
      {
        link: '/loans/debt-consolidation/',
        title: 'Debt consolidation',
        icon: 'ecs-font-icon-frs-chart-bar',
        advice: {
          mobileTitle: 'Debt consolidation',
          links: [
            {
              title: 'How to get a loan with bad credit',
              link: '/blogs/ask-experian/how-to-get-a-debt-consolidation-loan-with-bad-credit/',
            },
            {
              title: 'Personal loans to pay off credit card debt',
              link: '/blogs/ask-experian/should-i-get-a-personal-loan-to-pay-off-my-credit-card/',
            },
            {
              title: 'Payday loan consolidation',
              link: '/blogs/ask-experian/what-to-know-about-payday-loan-consolidation/',
            },
            {
              title: 'Is a debt consolidation loan right for you?',
              link: '/blogs/ask-experian/is-a-debt-consolidation-loan-right-for-you/',
            },
            {
              title: 'Checklist before applying for a loan',
              link: '/blogs/ask-experian/step-by-step-checklist-to-getting-a-consolidation-loan/',
            },
          ],
        },
      },
      {
        link: '/loans/personal/',
        title: 'Personal',
        icon: 'ecs-font-icon-ppl-user-consumers',
        advice: {
          mobileTitle: 'Personal',
          links: [
            {
              title: 'Best online personal loans',
              link: '/blogs/ask-experian/best-online-personal-loan-lenders/',
            },
            {
              title: 'What to know before applying for a loan',
              link: '/blogs/ask-experian/personal-loans-what-to-know-before-you-apply/',
            },
            {
              title: 'Types of personal loans',
              link: '/blogs/ask-experian/types-of-personal-loans/',
            },
            {
              title: 'What is a credit-builder loan?',
              link: '/blogs/ask-experian/what-is-a-credit-builder-loan/',
            },
            {
              title: 'Average personal loan debt',
              link: '/blogs/ask-experian/research/personal-loan-study/',
            },
          ],
        },
      },
      {
        link: '/credit/loans/student-loan/',
        title: 'Student',
        icon: 'ecs-font-icon-ccm-student',
        advice: {
          mobileTitle: 'Student',
          links: [
            {
              title: 'How to get a student loan',
              link: '/blogs/ask-experian/how-to-get-a-student-loan/',
            },
            {
              title: 'How to pay off student loans',
              link: '/blogs/ask-experian/how-pay-off-student-loans-as-a-new-graduate/',
            },
            {
              title: 'How student loans impact your credit',
              link: '/blogs/ask-experian/will-paying-off-student-loans-hurt-my-credit-score/',
            },
            {
              title: 'Average student loan debt',
              link: '/blogs/ask-experian/state-of-student-loan-debt/',
            },
          ],
        },
      },
    ],
    promo: {
      badge: 'PERSONAL LOANS',
      title: 'Find the right loan for you',
      body: 'Compare personal loan offers matched to your credit profile.',
      linkTitle: 'See your loan options',
      link: '/credit/loans/',
    },
  },
  {
    id: 'aut' as menuIdNames,
    titleCopy: 'Auto',
    mainLink: '/consumer-products/car-insurance-quotes.html',
    dataLink: 'nav-ia-auto',
    adviceTitle: 'Auto advice',
    drpMainCategories: [
      {
        subcopy: 'Compare, switch and save',
        icon: 'ecs-font-icon-ccm-auto',
        link: '/consumer-products/car-insurance-quotes.html',
        title: 'Auto insurance',
        advice: {
          mobileTitle: 'Most popular',
          links: [
            {
              title: 'How to save on car insurance',
              link: '/blogs/ask-experian/how-to-save-on-auto-insurance/',
            },
            {
              title: 'Factors that impact car insurance rates',
              link: '/blogs/ask-experian/factors-that-determine-your-car-insurance-rates/',
            },
            {
              title: 'What is liability insurance?',
              link: '/blogs/ask-experian/what-is-liability-insurance/',
            },
            {
              title: 'What is gap insurance?',
              link: '/blogs/ask-experian/what-is-gap-insurance/',
            },
            {
              title: 'Do you need insurance for a rental car?',
              link: '/blogs/ask-experian/do-i-need-insurance-to-rent-a-car/',
            },
            {
              title: 'Cheapest states for car insurance',
              link: '/blogs/ask-experian/research/cheapest-states-for-car-insurance/',
            },
          ],
        },
      },
    ],
    promo: {
      badge: 'AUTO BENEFITS',
      title: 'Get all the facts about your car',
      body: 'View your car’s estimated value, history, recalls and more—all free.',
      linkTitle: 'Get free access',
      link: formRegistrationUrl({
        offer: 'at_frsas119',
        authType: '102',
        refUrl: refRegistrationParams.carGarage,
      }),
    },
  },
];
